var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9478 30.9099C24.5418 30.9099 30.6978 24.7539 30.6978 17.1599C30.6978 9.56593 24.5418 3.40985 16.9478 3.40985C9.35383 3.40985 3.19775 9.56593 3.19775 17.1599C3.19775 24.7539 9.35383 30.9099 16.9478 30.9099ZM16.9478 33.4099C25.9223 33.4099 33.1978 26.1343 33.1978 17.1599C33.1978 8.18523 25.9223 0.909851 16.9478 0.909851C7.97313 0.909851 0.697754 8.18523 0.697754 17.1599C0.697754 26.1343 7.97313 33.4099 16.9478 33.4099Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8454 27.0576C27.3334 26.5693 28.1249 26.5693 28.6132 27.0576L36.5817 35.0261C37.0697 35.5141 37.0697 36.3056 36.5817 36.7938C36.0934 37.2818 35.3019 37.2818 34.8139 36.7938L26.8454 28.8253C26.3572 28.3371 26.3572 27.5456 26.8454 27.0576Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c823882a0c02aac32dfe004d47bac8a8.svg";
export { ForwardRef as ReactComponent };